<h6>Header Customization</h6>
<div class="mb-4">
    <app-color-picker label="Header Background Color" formControlName="headerBackgroundColor" />
    <div class="my-4">
        <mat-slide-toggle formControlName="isGradientEnabled">Enable Gradient For Header Background</mat-slide-toggle>
    </div>
    @if (isGradientEnabled$ | async) {
        <div class="my-4">
            <app-color-picker label="Header Background Color 30" formControlName="headerBackgroundColor30" />
        </div>
        <div class="my-4">
            <app-color-picker label="Header Background Color 62" formControlName="headerBackgroundColor62" />
        </div>
        <div class="my-4">
            <app-color-picker label="Header Background Color 100" formControlName="headerBackgroundColor100" />
        </div>
        <div class="mt-4 mb-5">
            <div class="header-preview__label">Gradient Header Preview</div>
            <div class="header-preview__bar" [style.background]="headerPreviewBackground$ | async"></div>
        </div>
    }
</div>
<div class="my-4">
    <mat-slide-toggle formControlName="headerTextActiveColor">Header Text Active Color</mat-slide-toggle>
</div>
@if (headerTextActiveColor$ | async) {
    <div class="mb-4">
        <app-color-picker label="Header Text Color" formControlName="headerTextColor" />
    </div>
}
